import React, { useState } from "react";
import { Container, TextField, Button, Grid, Box } from "@mui/material";
const LoginControl = ({ onLogIn }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const handleSubmit = (event) => {
        event.preventDefault();
        onLogIn(email, password);
    };
    return (React.createElement(Container, { maxWidth: "sm" },
        React.createElement(Box, { sx: { mt: 1 } },
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Email", variant: "outlined", fullWidth: true, value: email, onChange: (e) => setEmail(e.target.value), required: true })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { label: "Password", type: "password", variant: "outlined", fullWidth: true, value: password, onChange: (e) => setPassword(e.target.value), required: true })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Button, { type: "submit", variant: "contained", sx: {
                                background: "linear-gradient(45deg, #005533 30%, #003322 90%)",
                            }, fullWidth: true }, "Login")))))));
};
export default LoginControl;
